import { createSlice, PayloadAction, createSelector } from "@reduxjs/toolkit";
import { SourceType } from "../models";
import { RootState } from "../store";
import Storage from "../storage";
import { Notification } from '../models';

interface ImparcialApp {
    currentComponent: SourceType,
    sessionToken: string,
    selectedNotification?: Notification,
    channel: string,
    setNotificationsVisible: boolean
}

const token = Storage.getSessionToken();

const initialState: ImparcialApp = {
    currentComponent: SourceType.ENDI,
    sessionToken: token,
    selectedNotification: undefined,
    channel: "",
    setNotificationsVisible: false
}

export const imparcialSlice = createSlice({
    name: "imparcial",
    initialState,
    reducers: {
        updateCurrentComponent: (state, action: PayloadAction<SourceType>) => {
            state.currentComponent = action.payload;
        },
        updateSessionToken: (state, action: PayloadAction<string>) => {
            state.sessionToken = action.payload;
            Storage.setSessionToken(action.payload);
        },
        updateSelectedNotification: (state, action: PayloadAction<Notification>) => {
            state.selectedNotification = action.payload;
        },
        updateChannel: (state, action: PayloadAction<string>) => {
            state.channel = action.payload;
        },
        updateSetNotificationsVisible: (state, action: PayloadAction<boolean>) => {
            state.setNotificationsVisible = action.payload;
        }
    }
});

export const selectCurrentComponent = (state: RootState) => state.imparcial.currentComponent;

export const selectChannel = (state: RootState) => state.imparcial.channel;

export const { updateCurrentComponent, updateSessionToken, updateSelectedNotification, updateChannel, updateSetNotificationsVisible } = imparcialSlice.actions

export default imparcialSlice.reducer;
